import {
  Heading,
  Img,
  Stack,
  Text,
  useBreakpointValue,
  VStack,
} from '@chakra-ui/react';

import { Button, Link, PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';
import { Paths } from 'utils/paths';

export const CitySection = () => {
  const { content } = usePageTextContent<StoresPageContent>();

  const { title, description, findCityGiftcardButton, pictureUrl } =
    content.city;

  const columns = useBreakpointValue([
    '15.75rem auto',
    '15.75rem auto',
    '15.75rem auto',
    '18.75rem auto',
  ]);

  return (
    <PageContainer bgGradient="linear(to-r, blue.600, blue.800)">
      <PageContent>
        <Stack
          direction={['column', 'column', 'row']}
          spacing="2.25rem"
          align="center"
          justify="space-between"
          w="full"
        >
          <VStack align="flex-start" spacing="5rem">
            <VStack align="flex-start" spacing="1rem" color="white">
              <Heading
                fontSize="1.5rem"
                color="store.secondary"
                whiteSpace="pre-line"
              >
                {title}
              </Heading>
              <Text fontSize="1.125rem" style={{ columns }}>
                {description}
              </Text>
            </VStack>
            <Link href={Paths.NETWORK_GIFTCARDS}>
              <Button
                variant="store"
                borderWidth="2px"
                borderStyle="solid"
                borderColor="white"
              >
                {findCityGiftcardButton}
              </Button>
            </Link>
          </VStack>

          <Img
            src={pictureUrl}
            w={['full', 'full', '30%', 'full']}
            maxW="32rem"
            mixBlendMode="color-dodge"
            alt="Network"
            loading="lazy"
          />
        </Stack>
      </PageContent>
    </PageContainer>
  );
};
